import api from "../api";
/* eslint-disable */
export default {
  namespaced: true,
  state: {
    Booking: [],

  },
  getters: {
    getBooking(state) {
      return state.Booking;
    },
  },
  mutations: {
    SetBooking(state, data) {
      state.Booking = [];
      state.Booking = data.map(ride => ({
        ...ride,
        rideDate: new Date(ride.rideDate),
        statusTime: new Date(ride.statusTime),
        bookDate: new Date(ride.bookDate),
        seatsCount: Number(ride.seatsCount),

        id: Number(ride.id)

      }));;;
    },

  },
  actions: {
    addPssenger({ commit }, data) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `booking/book_ride`,
            {
              name: data.name,
              phone: data.phone,
              pickupStopId: data.pickupStopId,
              dropOffStopId: data.dropOffStopId,
              seatsCount: data.seatsCount,
              pickupStopSortNum: data.pickupStopSortNum,
              dropOffStopSortNum: data.dropOffStopSortNum,
              realRideId: data.realRideId,
              seatsNumbers: data.seatsNumbers,//array of seat ids
            },
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {

            resolve(res);
          })
          .catch((err) => resolve(err));
      })
    },
    book_ride({ commit }, data) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `booking/book_ride2`,
            data,
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {

            resolve(res);
          })
          .catch((err) => resolve(err));
      })
    },
    rebook({ commit }, data) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `booking/rebook`,
            data,
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {

            resolve(res);
          })
          .catch((err) => {
            debugger
            resolve(err.response.data);
          })
      })
    },
    cancelBooking({ commit }, data) {
      return new Promise((resolve, rej) => {
        api()
          .post(`booking/cancel_booking`, {
            bookingId: data.bookingId,
          }, {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          }
          )
          .then((res) => {
            resolve(res);
          })
          .catch((err) => resolve(err));
      })
    },

    getBookingByDate({ commit }, data) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `booking/getBookingByDate`,
            data,
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            commit("SetBooking", res.data);
            resolve()
          })
          .catch((err) => {

            console.log(err)
          });
      })
    },

  },
};
